var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "85px",
    height: "42px",
    viewBox: "0 0 85 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconaMenu@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IconaMenu",
    fill: "#277A8A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 28.000000)",
    fontFamily: "Helvetica",
    fontSize: 12,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Il-tuo-preventivo"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "Il tuo preventivo"))), /*#__PURE__*/React.createElement("path", {
    d: "M23,19.111 L27.778,19.111 L27.778,23.889 L23,23.889 L23,19.111 Z M32.556,19.111 L66,19.111 L66,23.889 L32.556,23.889 L32.556,19.111 Z M23,9.553 L27.778,9.553 L27.778,14.333 L23,14.333 L23,9.553 Z M32.556,9.553 L66,9.553 L66,14.333 L32.556,14.333 L32.556,9.553 Z M23,0 L27.778,0 L27.778,4.778 L23,4.778 L23,0 Z M32.556,0 L66,0 L66,4.778 L32.556,4.778 L32.556,0 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaMenu);
export default __webpack_public_path__ + "static/media/IconaMenu.6fee8403866f6f3cef2c009cccbc5e48.svg";
export { ForwardRef as ReactComponent };